<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="title">
              <h2>Aplikimi per agjent: {{ agentRequestDetails.first_name }} {{ agentRequestDetails.last_name }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <form>
            <div class="col-12">
              <div class="white-background mb-30">
                <div class="form-group">
                  
                  <label>Të dhënat e aplikuesit</label>

                  <table class="tab-style table" v-if="agentRequestDetails.type ==='individual'">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td>Emri</td>
                      <td>{{ agentRequestDetails.first_name }}</td>
                    </tr>
                    <tr>
                      <td>Mbiemri</td>
                      <td>{{ agentRequestDetails.last_name }}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{{ agentRequestDetails.email }}</td>
                    </tr>
                    <tr>
                      <td>Telefoni</td>
                      <td>{{ agentRequestDetails.phone_number }}</td>
                    </tr>
                    <tr>
                      <td>ID Personale</td>
                      <td>{{ agentRequestDetails.personal_id }}</td>
                    </tr>
                    <tr>
                      <td>Adresa</td>
                      <td>{{ agentRequestDetails.address }}</td>
                    </tr>
                    <tr>
                      <td>Lloji i Aplikimit</td>
                      <td>{{ agentRequestDetails.type == 'company' ? 'Biznes / Institucion' : 'Individual' }}</td>
                    </tr>
                  </table>
                  <table class="tab-style table" v-if="agentRequestDetails.type ==='company'">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td>Emri i Kompanisë</td>
                      <td>{{ agentRequestDetails.company_name }}</td>
                    </tr>
                    <tr>
                      <td>Numri i Biznesit</td>
                      <td>{{ agentRequestDetails.business_number }}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>{{ agentRequestDetails.email }}</td>
                    </tr>
                    <tr>
                      <td>Telefoni</td>
                      <td>{{ agentRequestDetails.phone_number }}</td>
                    </tr>
                    <tr>
                      <td>Adresa</td>
                      <td>{{ agentRequestDetails.address }}</td>
                    </tr>
                    <tr>
                      <td>Lloji i Aplikimit</td>
                      <td>{{ agentRequestDetails.type == 'company' ? 'Biznes / Institucion' : 'Individual' }}</td>
                    </tr>
                  </table>
                  <label>Statusi i Kerkeses</label>
                  <table class="tab-style table">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td>Statusi</td>
                      <td>{{ agentRequestDetails.approved == true ? 'Aprovuar' : 'Ne pritje / Refuzuar' }}</td>
                    </tr>
                  </table>
                  <label>Të dhënat e veturës</label>
                  <table class="tab-style table" v-for="(vehicle, index) in agentRequestDetails.vehicles" :key="index">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td><strong>Vetura Nr. {{ index + 1}}</strong></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Model</td>
                      <td>{{ vehicle.vehicle_model }}</td>
                    </tr>
                    <tr>
                      <td>Targat</td>
                      <td>{{ vehicle.vehicle_registration }}</td>
                    </tr>
                    <tr>
                      <td>Pronari i Automjetit sipas Librezes</td>
                      <td>{{ vehicle.vehicle_owner_name }}</td>
                    </tr>
                    <tr>
                      <td>Transmisioni</td>
                      <td>{{ vehicle.vehicle_transmission }}</td>
                    </tr>
                    <tr>
                      <td>Viti i regjistrimit</td>
                      <td>{{ vehicle.vehicle_registration_year }}</td>
                    </tr>
                  </table>
                  <label>Të dhënat e llogarisë bankare</label>
                  <table class="tab-style table">
                    <colgroup>
                      <col style="width:40%">
                      <col style="width:60%">
                    </colgroup>
                    <tr>
                      <td>Emri i mbajtesit te llogarise</td>
                      <td>{{ agentRequestDetails.bank_holder_name }}</td>
                    </tr>
                    <tr>
                      <td>Adresa e mbajtesit te llogarise</td>
                      <td>{{ agentRequestDetails.bank_holder_address }}</td>
                    </tr>
                    <tr>
                      <td>Emri i bankes</td>
                      <td>{{ agentRequestDetails.bank_name }}</td>
                    </tr>
                    <tr>
                      <td>Numri i llogarise</td>
                      <td>{{ agentRequestDetails.bank_account_number }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="d-flex flex-column flex-md-row justify-content-between confirmation">
                <router-link class="mb-2 mb-md-0" tag="button" to="/admin/agents/requests">KTHEHU</router-link>
                <button class="mb-2 mb-md-0 btn-custom-danger" type @click="rejectAgentRequest">refuzo kerkesen</button>
                <button class="mb-2 mb-md-0" type @click="approveAgentRequest">konfirmo kerkesen</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import "moment";

export default {
  name: "AdminPaymentDetail",
  components: {
    AdminSidebar: AdminSidebar
  },
  methods: {
    rejectAgentRequest(e) {
      e.preventDefault();
      this.$store.dispatch("agents/rejectAgentRequest", this.$route.params.id);
    }, 
    approveAgentRequest(e) {
      e.preventDefault();
      this.$store.dispatch("agents/approveAgentRequest", this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters({
      agentRequestDetails: "agents/agentRequestDetails",
      approved : "agents/approved"
    })
  },
  beforeMount() {
    this.$store.dispatch(
      "agents/getAgentRequestDetails",
      this.$route.params.id
    );
  }
};
</script>
